
  import kenticoRuntime$c5VWIcq_fTtE9u08mz9u04HnwQEPXDjGXD_BCj9BaMo from '/home/vsts/work/1/s/providers/kentico.ts'
import ipxRuntime$Yz6t6EezgLS0JjMNhtjX4WxsaC7Phwcm_eR5R3bdJEI from '/home/vsts/work/1/s/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "media.jpc.africa"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 80
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['kentico']: { setup: kenticoRuntime$c5VWIcq_fTtE9u08mz9u04HnwQEPXDjGXD_BCj9BaMo, defaults: undefined },
  ['ipx']: { setup: ipxRuntime$Yz6t6EezgLS0JjMNhtjX4WxsaC7Phwcm_eR5R3bdJEI, defaults: {} }
    }
  }
